module.exports = __webpack_public_path__ + "static/media/Prajwal_Bhosale.24d05743.jpg";